<template>
  <span>
     <span class="system-message" v-if="message.messageType=='ViewerAction'">
       <chatbot-message-viewer-action :message="parsedMessage" />
    </span>
    <span class="system-message" v-else-if="isChart(message.messageType)">
      <chatbot-message-chart :message="parsedMessage"></chatbot-message-chart>
    </span>
    <span v-else-if="message.messageType=='query'" class="system-message" v-html="formatLLMResponse(message.content)">
    </span>
  </span>
</template>

<script>
import { log, warn, error } from '@/utils/debugLogger';
import { marked } from 'marked';
import chatbotMessageChart from './chatbot-message-chart.vue';
import ChatbotMessageViewerAction from './chatbot-message-viewer-action.vue';
export default {
  components: { chatbotMessageChart, ChatbotMessageViewerAction },
props:['message'],

methods:{
  formatLLMResponse(rawText) {
    if (!rawText)
      return '';
    const html = marked.parse(rawText);
    return html;
  },
  isChart(type){
    var chartTypes=['pie','bar','column','radar','area','line','count','table'];
    return chartTypes.includes(type);
  }
},
computed:{
  parsedMessage(){
    var msg=this.message;
    if(!msg) return msg;

    try {
      msg.content=JSON.parse(msg.content);
      
    } catch (err) {
      error("Couldn't parse message content", err);
    }
    return msg;
  }
 
}
}
</script>

<style>

</style>